import {
  Box,
  Button,
  Container,
  Input,
  InputGroup,
  InputLeftElement,
  Link,
} from "@chakra-ui/react";
import ComposerTable from "components/PaginationTable";
import dayjs from "dayjs";
import { FaPencilAlt, FaEye } from "react-icons/fa";
import { composersRequest } from "services/httpService";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useQueryWrapper } from "services/apiHelper";
import { useDispatch } from "react-redux";
import { editComposers } from "lib/redux/scripts/action";

import { queryKeys } from "services/querykeys";
import { PROTECTED_PATHS } from "routes/pagePath";
import { AiOutlineSearch } from "react-icons/ai";
import { useState, useEffect } from "react";
const Composer = () => {
  const { data: allComposers, isLoading } = useQueryWrapper(
    queryKeys.COMPOSERS,
    composersRequest.COMPOSER,
  );
  const dispatch = useDispatch();
  const history = useNavigate();

  const composersData = allComposers.data;
  const COLUMNS = [
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Nickname",
      accessor: "nickname",
    },
    {
      Header: "No of scripts",
      accessor: "user.userName",
    },
    {
      Header: "Created On",
      Cell: function uploaded({ cell }: any) {
        return <div> {dayjs(cell.row.original.createdAt).format("MMM D YYYY")}</div>;
      },
    },

    {
      Header: "Edit",
      Cell: function edit({ cell }) {
        return (
          <Button
            onClick={() => {
              dispatch(editComposers(cell.row.original));
              history(`${PROTECTED_PATHS.EDIT_COMPOSER}?edit=${cell.row.original.slug}`);
            }}
          >
            <FaPencilAlt />
          </Button>
        );
      },
    },

    {
      Header: "View",
      Cell: ({ cell }: any) => (
        <Button
          variant="secondary"
          onClick={() => {
            history(`/composer/${cell.row.original.id}`);
          }}
        >
          <FaEye />
        </Button>
      ),
    },
  ];

  const [searchComposer, setSearchComposer] = useState("");

  const [filteredComposer, setFilteredComposer] = useState<any>([]);

  useEffect(() => {
    if (searchComposer) {
      const searchLower = searchComposer.toLowerCase();
      setFilteredComposer(
        composersData.filter(({ name }) => name.toLowerCase().includes(searchLower)),
      );
    } else {
      setFilteredComposer(composersData);
    }
  }, [composersData, searchComposer]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Container mt="4" maxW="container.xl">
      <Box p={"0 10px"} mt="2">
        <InputGroup mb={[8, 8, null]} w="100%">
          <InputLeftElement pointerEvents="none">
            <AiOutlineSearch color="gray.300" />
          </InputLeftElement>
          <Input
            value={searchComposer}
            onChange={(e) => {
              setSearchComposer(e.target.value);
            }}
            type="search"
            placeholder="Search Composer"
          />
        </InputGroup>
      </Box>
      <Button>
        <Link as={RouterLink} to="new" variant="button">
          Create Composer
        </Link>
      </Button>

      <Box>Composer list</Box>

      <ComposerTable columns={COLUMNS} data={filteredComposer} loading={isLoading} />
    </Container>
  );
};

export default Composer;
